import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
const attendanceApi = factory.get("attendance");

const initialState = {
  hr_attendance: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      skip: 0,
      take: 15,
      user_id: null,
      fingerprint_id: "",
      department_id: null,
      start_date: "",
      end_date: "",
      page: 0,
    },
  },
  my_attendance: {
    loading: false,
    all: [],
    total: 0,
    ten_days: [],
    dialog: false,
  },
  attendance_status: {
    loading: false,
    data: {
      day_cut: "",
      delay_minutes: "",
      hourly_leaves: "",
      pending_leaves: "",
      remaining_delay_minutes: "",
      remaining_hourly_leaves: "",
      remaining_leaves: "",
    },
  },
  attendence_log: {
    dialog: false,
    params: {
      user_id: "",
      date: "",
      attendance_id: "",
    },
    loading: false,
    data: [],
  },
  attendence_day_update: {
    dialog: false,
    params: {
      id: "",
      check_in: null,
      check_out: null,
      employee_name: "",
    },
    loading: false,
    data: [],
  },
  attendence_map: {
    dialog: false,
    data: {},
  },
  clear_attendance: {
    dialog: false,
    loading: false,
    params: {
      id: "",
      employee_name: "",
      fingerprint_date: "",
    },
  },
};

export const attendanceSlice = createSlice({
  name: "attendance",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setMyAttendanceDialog: (state, action) => {
      state.my_attendance.dialog = !state.my_attendance.dialog;
    },
    setMyAttendanceTable: (state, { payload }) => {
      state.my_attendance.all = payload.data.data;
      state.my_attendance.total = payload.data.total;
    },
    setMyAttendanceTenDaysTable: (state, { payload }) => {
      state.my_attendance.ten_days = payload.data.data;
    },
    setHrTable: (state, { payload }) => {
      state.hr_attendance.data = payload.data.data;
      state.hr_attendance.total = payload.data.total;
    },
    setAttendanceStatus: (state, { payload }) => {
      state.attendance_status.data = payload.data.data[0];
    },
    setFilters: (state, { payload }) => {
      state.hr_attendance.filters = {
        ...state.hr_attendance.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.hr_attendance.filters = initialState.hr_attendance.filters;
    },
    setAttendanceLogDialog: (state, { payload }) => {
      if (payload) {
        state.attendence_log.params = { ...payload };
      } else {
        state.attendence_log.params = initialState.attendence_log.params;
      }
      state.attendence_log.dialog = !state.attendence_log.dialog;
    },
    setAttendanceLogData: (state, { payload }) => {
      state.attendence_log.data = payload.data.data;
    },
    setAttendanceUpdateDayDialog: (state, { payload }) => {
      if (payload) {
        state.attendence_day_update.params = { ...payload };
      } else {
        state.attendence_day_update.params =
          initialState.attendence_day_update.params;
      }
      state.attendence_day_update.dialog = !state.attendence_day_update.dialog;
    },
    setAttendanceMapDialog: (state, { payload }) => {
      if (payload) {
        state.attendence_map.data = { ...payload };
      } else {
        state.attendence_map.data = initialState.attendence_map.data;
      }
      state.attendence_map.dialog = !state.attendence_map.dialog;
    },
    setClearAttendanceDialog: (state, { payload }) => {
      if (payload) {
        state.clear_attendance.params = { ...payload };
      } else {
        state.clear_attendance.params = initialState.clear_attendance.params;
      }
      state.clear_attendance.dialog = !state.clear_attendance.dialog;
    },
  },
});

export const {
  setLoading,
  setMyAttendanceTable,
  setMyAttendanceTenDaysTable,
  setHrTable,
  setMyAttendanceDialog,
  setAttendanceStatus,
  setFilters,
  resetFilters,
  setAttendanceLogDialog,
  setAttendanceLogData,
  setAttendanceUpdateDayDialog,
  setAttendanceMapDialog,
  setClearAttendanceDialog,
} = attendanceSlice.actions;

export default attendanceSlice.reducer;

//axios
const getAll = () => async (dispatch, getState) => {
  try {
    const filters = getState().attendance.hr_attendance.filters;
    let _filters = {
      ...filters,
      department_id: filters.department_id ? filters.department_id.id : null,
      user_id: filters.user_id ? filters.user_id.id : null,
    };
    dispatch(setLoading("hr_attendance"));
    const res = await attendanceApi.getAll(_filters);
    dispatch(setHrTable(res));
    dispatch(setLoading("hr_attendance"));
  } catch (err) {
    dispatch(setLoading("hr_attendance"));
    throw new Error(err);
  }
};
const getAllMyAttendance = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("my_attendance"));
    const res = await attendanceApi.forMyAttendance(params);
    dispatch(setMyAttendanceTable(res));
    dispatch(setLoading("my_attendance"));
  } catch (err) {
    dispatch(setLoading("my_attendance"));
    throw new Error(err);
  }
};
const getTenDays = () => async (dispatch) => {
  try {
    dispatch(setLoading("my_attendance"));
    const res = await attendanceApi.forTenDays();
    dispatch(setMyAttendanceTenDaysTable(res));
    dispatch(setLoading("my_attendance"));
  } catch (err) {
    dispatch(setLoading("my_attendance"));
    throw new Error(err);
  }
};
const getAttendanceStatus = () => async (dispatch) => {
  try {
    dispatch(setLoading("attendance_status"));
    const res = await attendanceApi.attendanceStatus();
    dispatch(setAttendanceStatus(res));
    dispatch(setLoading("attendance_status"));
  } catch (err) {
    dispatch(setLoading("attendance_status"));
    throw new Error(err);
  }
};
const checkInOutRemotely = (data) => async (dispatch) => {
  try {
    await attendanceApi.remotlyCheckInOut(data);

    dispatch(
      showNotification({
        message: "تم تسجيل البصمة بنجاح",
        type: "success",
      })
    );
    dispatch(setMyAttendanceDialog());
    dispatch(getAllMyAttendance());
  } catch (err) {
    dispatch(setLoading("attendance_status"));
    throw new Error(err);
  }
};
const recalculateAttendance = (data) => async (dispatch) => {
  try {
    // dispatch(setLoading('attendance_status'));
    const res = await attendanceApi.recalculateAttendance(data);
    // dispatch(setAttendanceStatus(res));
    // dispatch(setLoading('attendance_status'));
    dispatch(
      showNotification({
        message: "تم  اعادة احتساب الوقت",
        type: "success",
      })
    );
    dispatch(getAll());
  } catch (err) {
    dispatch(setLoading("attendance_status"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
//recalculate for all users
const recalculateAllAttendance = (data) => async (dispatch) => {
  try {
    await attendanceApi.recalculateAllAttendance(data);
    dispatch(
      showNotification({
        message: "تم  اعادة احتساب الوقت",
        type: "success",
      })
    );
    return { status: true };
  } catch (err) {
    return { status: false };
    throw new Error(err);
  }
};
const attendanceDayLog = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading("attendence_log"));
    const params = getState().attendance.attendence_log.params;
    const res = await attendanceApi.getDayAttendanceLog(params);
    dispatch(setAttendanceLogData(res));
    dispatch(setLoading("attendence_log"));
  } catch (err) {
    dispatch(setLoading("attendence_log"));
    throw new Error(err);
  }
};
const updateAttendanceDayLog = (data) => async (dispatch) => {
  try {
    await attendanceApi.updateDayAttendanceLog(data);
    dispatch(
      showNotification({
        message: "تم تعديل البصمة بنجاح",
        type: "success",
      })
    );
    dispatch(setAttendanceLogDialog());
    dispatch(getAll());
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const updateAttendanceDayCheckInOut = (data) => async (dispatch) => {
  try {
    await attendanceApi.updateDayAttendanceCheckInOut(data);
    dispatch(
      showNotification({
        message: "تم تعديل البصمة بنجاح",
        type: "success",
      })
    );
    dispatch(setAttendanceUpdateDayDialog());
    dispatch(getAll());
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const deleteAttendance = (id) => async (dispatch) => {
  try {
    await attendanceApi.deleteAttendance(id);
    dispatch(
      showNotification({
        message: "تم الحذف  بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
    return true;
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const clearAttendance = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("clear_attendance"));
    await attendanceApi.clearAttendance(data);
    dispatch(
      showNotification({
        message: "تم حذف بصمة الدخول و الخروج بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
    dispatch(setLoading("clear_attendance"));
    return true;
  } catch (err) {
    dispatch(setLoading("clear_attendance"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const Attendance = {
  getAll,
  getAllMyAttendance,
  getTenDays,
  getAttendanceStatus,
  checkInOutRemotely,
  recalculateAttendance,
  recalculateAllAttendance,
  attendanceDayLog,
  updateAttendanceDayLog,
  updateAttendanceDayCheckInOut,
  deleteAttendance,
  clearAttendance,
};
